export const currencyFormatter = new Intl.NumberFormat(undefined, {
  currency: "ars",
  style: "currency",
  minimumFractionDigits: 0,
})
